import React from 'react'
import loadable from '@loadable/component'
const IconSVG = loadable(() => import(/*webpackChunkName: 'icons'*/"./IconsSVG"))

class Icon extends React.Component{
  render(){
    return(
      <IconSVG name={this.props.name} questionCount={this.props.questionCount} />
    )
  }
}

export default Icon
